/** 界面语言。全站一份，不按个人/团队或平台工作区分开记。 */
export const IPE_UI_LOCALES = [
  { code: 'zh-CN', label: '简体中文' },
  { code: 'en', label: 'English' },
  { code: 'pt-BR', label: 'Português' },
  { code: 'es', label: 'Español' },
  { code: 'de', label: 'Deutsch' },
  { code: 'fr', label: 'Français' },
  { code: 'it', label: 'Italiano' },
  { code: 'ja', label: '日本語' },
  { code: 'ko', label: '한국어' },
  { code: 'th', label: 'ไทย' },
  { code: 'vi', label: 'Tiếng Việt' },
  { code: 'id', label: 'Bahasa Indonesia' },
];

export const IPE_UI_LOCALE_CODES = IPE_UI_LOCALES.map((item) => item.code);

export const IPE_UI_LOCALE_STORAGE_KEY = 'ipe_ui_locale';

export const IPE_UI_LOCALE_EVENT = 'ipe:ui-locale-changed';

export function normalizeIpeUiLocale(raw) {
  const value = String(raw || '').trim();
  return IPE_UI_LOCALE_CODES.includes(value) ? value : 'zh-CN';
}
